import React, { useEffect } from 'react';
import { Col, Row } from 'antd';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { propsToJS } from '__utils/immutable-to-js';
import { CommonStyledComponentProps } from '__utils/type';
import { LayoutContext } from 'components/app-routes';
import UserBankInfoSlab from '../user-bank-info-slab';
import PaymentViewSelector from '../payment-flow.selector';
import ChequeDetails from './cheque-details';
import ChequeForm from './cheque-form';
import { WhiteCardWrapper } from 'views/common-styled-components';
import { useSelector } from 'react-redux';
import { COLOR } from 'constants/colors';
import VerifiedMark from 'components/verified-icon-text';
import { addAgentCode, isProUser } from '__utils/common-utils';
import { PaymentFlowHelper } from '../paymentFlow.helper';


const ChequeDetailsWhiteCard = styled.div<CommonStyledComponentProps>`
    input{
        width: 100%;
        color: black;
    }
    h5 {
    font-size: 16px;
    color: ${COLOR.GREEN};
    line-height: normal;
    font-weight: 500;
    padding: 10px 0px
    }
`;

const ChequePayment: React.FC = () => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { totalValidOrdersAmount,userPaymentDetailView } = propsToJS(useSelector(PaymentViewSelector));
    // eslint-disable-next-line
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);
    const { getBSEorderDetails } = PaymentFlowHelper();


    useEffect(() => {
        SetLayoutProps({
            config: { title: 'Cheque Payment Details' },
            breadcrumbList: [ { text: 'Home', url: addAgentCode('v1/home'), isExternal: true }, { text: 'Investment Cart', url: '/cart-review', isExternal: true }, { text: 'Cheque Payment', url: '' } ],
            showCopyrightInfoForDesktop: true,
        })
        userPaymentDetailView && userPaymentDetailView?.length === 0 && getBSEorderDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (<div>
        { isMobile && <div style={ { margin: '16px', marginTop: isProUser() ? '24px' : '60px' } }>
            <UserBankInfoSlab />
        </div> }
        <Row gutter={ 32 } style={ { width: '100%', margin: '0px auto' } }>
            <Col xs={ 24 } md={ 16 } >
                <WhiteCardWrapper isMobile={ isMobile } style={ { width: '100%', height: !isMobile ? '100%' : '', paddingRight: isMobile ? '16px' : '24px' } }>
                    <ChequeDetailsWhiteCard isMobile={ isMobile }>
                        { !isMobile && <div>
                            <UserBankInfoSlab vertical />
                            <br />
                        </div>
                        }
                        <div style={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
                            <h5>Step 1</h5>
                            <VerifiedMark />
                        </div>
                        <ChequeDetails /><br />
                    </ChequeDetailsWhiteCard>
                    { isMobile && <ChequeForm /> }
                </WhiteCardWrapper>
            </Col>

            <Col xs={ 0 } md={ 8 }>
                <div className='mint-box flex-col-container'>
                    { !isMobile &&
                        <Row style={ { justifyContent: 'space-between' } }>
                            <Col style={ { color: '#4D5556', fontSize: '18px' } }>
                                Total Investment :
                            </Col>
                            <Col >
                                <b className='totalAmountTitle'> ₹ { totalValidOrdersAmount?.toLocaleString(navigator.language, { minimumFractionDigits: 2 }) }</b>
                            </Col>
                        </Row>
                    }<br />
                    { !isMobile && <ChequeForm /> }
                </div>

            </Col>
        </Row>
    </div>);
};

export default ChequePayment;

